import React from 'react'
import MetaTags from 'react-meta-tags'

import canonicalUrl from 'utils/canonicalUrl'

export default location => {
  return (
    <MetaTags>
      <link rel="canonical" href={canonicalUrl(location)} />
    </MetaTags>
  )
}
